export class UserLogin {
    public id: number
    public nome: string
    public email: string
    public senha: string
    public token: string
    public foto: string 
}